module.exports = __webpack_public_path__ + "img/talent_concept_1.a188275c.png";